import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { TOP_BANNER_HEIGHT } from '@/components/Banners/Banners.constants';

export const EmptyCollectionScreen = styled.div<{
  $isTopBannerVisible: boolean;
}>`
  display: flex;
  height: 100%;
  flex-grow: 1;
  padding: 15% 30px;
  text-align: center;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 50% 30px 0 30px;
    min-height: ${({ $isTopBannerVisible }) =>
      `calc(100vh - ${
        TOP_BANNER_HEIGHT + ($isTopBannerVisible ? TOP_BANNER_HEIGHT : 0)
      }px)`};
  }
`;

export const Title = styled(Typography.Header).attrs({
  $variant: '0',
})`
  margin-bottom: 10px;
`;

export const Description = styled(Typography.Caption).attrs({
  $variant: '1',
})`
  font-size: 16px;
  margin-bottom: 35px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
  }
`;

export const AddButton = styled(Button).attrs({
  height: 36,
  appearance: 'primary',
  borderRadius: 20,
})`
  padding: 0 10px;
`;
